// extracted by mini-css-extract-plugin
export default {"footerContainer":"Mqj-3","headerMenuList":"R87Qd","headerListItem":"_19gOf","depositLink":"_2P8f8","infoBlock":"_3DhK2","informationContainer":"_16rVv"};